import PropTypes from 'prop-types';

import {
  AVAILABILITY_LOCALIZED_STATUS,
  AVAILABILITY_LOCATION_TYPE,
  AVAILABILITY_ROLLUP_STATUS
} from 'app/constants/AvailabilityConstants';

export default PropTypes.exact({
  localizedStatus: PropTypes.oneOf(Object.values(AVAILABILITY_LOCALIZED_STATUS)),
  locationType: PropTypes.oneOf(Object.values(AVAILABILITY_LOCATION_TYPE)),
  numCopiesHeld: PropTypes.number.isRequired,
  numCopiesTotal: PropTypes.number.isRequired,
  rollupStatus: PropTypes.oneOf(Object.values(AVAILABILITY_ROLLUP_STATUS))
});
